import {useEffect} from "react";
import {AUTHORIZED_URL_PREFIX, AxiosConfig} from "./Constants";
import axios from "axios";

const useSessionDurationPlatform = ( durationUpdateInterval = 30000) => {
    useEffect(() => {
        let sessionTimer;
        let isPageVisible = true;

        const sessionStart = new Date().toISOString();
        localStorage.setItem('sessionStart', sessionStart);

        const updateSessionDuration = () => {
            if (isPageVisible) {
                // const duration = Math.floor((new Date() - new Date(sessionStart)) / 1000);
                const currentDate = new Date().toISOString();
                axios.post(`${AUTHORIZED_URL_PREFIX}/user/addActivity`, {currentDate}, AxiosConfig())
                    .then(response => {
                        if (response.status === 200) {
                            console.log(response.data)
                            console.log('Session updated successfully');
                        } else {
                            console.error('Failed to update session duration:', response.status);
                        }
                    })
                    .catch(error => console.error('Error updating session duration:', error));
            }
        };

        document.addEventListener('visibilitychange', () => {
            isPageVisible = !document.hidden;
            if (isPageVisible) {
                updateSessionDuration();
                sessionTimer = setInterval(updateSessionDuration, durationUpdateInterval); // Update duration every `durationUpdateInterval` milliseconds
            } else {
                clearInterval(sessionTimer);
            }
        });

        sessionTimer = setInterval(updateSessionDuration, durationUpdateInterval); // Update duration every `durationUpdateInterval` milliseconds

        return () => {
            clearInterval(sessionTimer);
            document.removeEventListener('visibilitychange', () => {
                isPageVisible = !document.hidden;
                if (isPageVisible) {
                    updateSessionDuration();
                    sessionTimer = setInterval(updateSessionDuration, durationUpdateInterval); // Update duration every `durationUpdateInterval` milliseconds
                } else {
                    clearInterval(sessionTimer);
                }
            });
        };

    }, []);
};

const startActivitySession = (activity) => {
    axios.post(`${AUTHORIZED_URL_PREFIX}/user/startActivity`, {activity}, AxiosConfig())
        .then(response => {
            if (response.status === 200) {
                console.log(response.data)
                console.log('Activity started successfully');
            } else {
                console.error('Failed to start activity:', response.status);
            }
        })
        .catch(error => console.error('Error starting session :', error));
}

const stopActivitySession = (activity, success) => {
    axios.post(`${AUTHORIZED_URL_PREFIX}/user/stopActivity`, {activity, success}, AxiosConfig())
        .then(respose => {
            if (respose.status === 200) {
                console.log(respose.data);
                console.log('Activity stopped successfully')
            } else {
                console.error('Failed to stop activity')
            }
        })
        .catch(error => console.error('Error stopping activity :', error))

}

const useUpdateActivitySession = (activity, isRunning) => {

    const durationUpdateInterval = 5000;

    useEffect(() => {
        let sessionTimer;
        let isPageVisible = true;

        const updateSessionDuration = () => {

            if (isPageVisible && isRunning) {
                const currentDate = new Date().toISOString();
                axios.post(`${AUTHORIZED_URL_PREFIX}/user/updateActivity`, {activity}, AxiosConfig())
                    .then(response => {
                        if (response.status === 200) {
                            console.log(response.data);
                            console.log('User duration activity updated successfully');
                        } else {
                            console.error('Failed to update session duration:', response.status);
                        }
                    })
                    .catch(error => console.error('Error updating session duration:', error));
            }
        };

        const handleVisibilityChange = () => {
            isPageVisible = !document.hidden;
            if (isPageVisible && isRunning) {
                updateSessionDuration();
                sessionTimer = setInterval(updateSessionDuration, durationUpdateInterval);
            } else {
                clearInterval(sessionTimer);
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        if (isRunning) {
            sessionTimer = setInterval(updateSessionDuration, durationUpdateInterval);
        }

        return () => {
            clearInterval(sessionTimer);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };

    }, [activity, isRunning]);

};


export {useSessionDurationPlatform, startActivitySession, useUpdateActivitySession, stopActivitySession};
